const csmKeys = {
  // View Grid,
  ROSTERING_CREDENTIALING: "rostering.credentialing",
  // Edit- Batch Approval,
  ROSTERING_CREDENTIALING_APPROVE: "rostering.credentialing.approve",
  // View Associated Data,
  ROSTERING_CREDENTIALING_ASSOCIATED_DATA: "rostering.credentialing.associated.data",
  // Edit - Review Action,
  ROSTERING_CREDENTIALING_EDIT: "rostering.credentialing.edit",
  // Sort/Filter grid,
  ROSTERING_CREDENTIALING_FILTER: "rostering.credentialing.filter",
  // Go to roster Record,
  ROSTERING_CREDENTIALING_GO: "rostering.credentialing.go",
  // View Request Details,
  ROSTERING_CREDENTIALING_REQUEST: "rostering.credentialing.request",
  // View and filter grid,
  ROSTERING_INSTITUTION: "rostering.institution",
  // rules realtes to edit/view instituion address and Contact added to src\components\@Institution\AddressContacts\AddressesContacts.js
  // View Address,
  ROSTERING_INSTITUTION_ADDRESS: "rostering.institution.address",
  // Modify Address,
  ROSTERING_INSTITUTION_ADDRESS_EDIT: "rostering.institution.address.edit",
  // View Contacts, :: added to route
  ROSTERING_INSTITUTION_CONTACT: "rostering.institution.contact",
  // Modify Contacts,
  ROSTERING_INSTITUTION_CONTACT_EDIT: "rostering.institution.contact.edit",

  // Attributes (Modify), // added to file src\containers\@Institution\@Roster\InstitutionAttributesContainer\index.js
  ROSTERING_INSTITUTION_ATTRIBUTES_MODIFY: "rostering.institution.attributes.modify",
  // Attributes (View), : added to route
  ROSTERING_INSTITUTION_ATTRIBUTES_VIEW: "rostering.institution.attributes.view",
  // Delete Record,
  ROSTERING_INSTITUTION_DELETE: "rostering.institution.delete",
  // Claim/modify institituion - edit, canEditAffilliation
  ROSTERING_INSTITUTION_EDIT: "rostering.institution.edit",
  ROSTERING_INSTITUTION_IRB_EXPIRY_EDIT: "rostering.institution.irbexpiry.edit",
  // Copy Person,
  ROSTERING_INSTITUTION_PERSON_COPY: "rostering.institution.person.copy",
  // View/Sort Browser,
  ROSTERING_INSTITUTION_ROSTER_BROWSER: "rostering.institution.roster.browser",
  // View Tree,
  ROSTERING_INSTITUTION_TREE: "rostering.institution.tree",
  // Request Transaction,
  ROSTERING_INSTITUTION_TX: "rostering.institution.tx",
  // View institution details,
  ROSTERING_INSTITUTION_VIEW: "rostering.institution.view",
  // View person details,
  ROSTERING_PERSON: "rostering.person",
  // Edit attribute response, added to src\containers\@Person\PersonRoster\PersonAttributesContainer.js
  ROSTERING_PERSON_ATTRIBUTE_EDIT: "rostering.person.attribute.edit",
  // View Attribute (for roster), added to route

  // use for both address and contacts
  ROSTERING_PERSON_ATTRIBUTE_VIEW: "rostering.person.attribute.view",
  ROSTERING_PERSON_CONTACT_EDIT: "rostering.person.contact.edit",
  ROSTERING_PERSON_CONTACT_VIEW: "rostering.person.contact.view",
  // Modify,
  ROSTERING_PERSON_DELETE: "rostering.person.delete",
  // View,
  // Delete Record,
  // Edit person record,
  ROSTERING_PERSON_EDIT: "rostering.person.edit",
  // View and filter grid,
  ROSTERING_PERSON_FILTER: "rostering.person.filter",
  // View person data,
  ROSTERING_PERSON_INSIGHT_VIEW: "rostering.person.insight.view",

  // adde to routes
  ROSTERING_PERSON_LMS_TRAINING_VIEW: "rostering.person.lms.training.view",
  ROSTERING_PERSON_REGISTRATION_DATA_VIEW: "rostering.person.registration.data.view",
  // View,
  ROSTERING_PERSON_ROLES_BROWSER: "rostering.person.roles.browser",
  // View,
  // View/Sort Browser,
  ROSTERING_PERSON_ROLES_EDIT: "rostering.person.roles.edit",
  ROSTERING_PERSON_ROLES_STATUS_EDIT: "rostering.person.roles.status.edit",
  // Modify,
  // Bulk Change Role Status,
  ROSTERING_PERSON_ROLES_VIEW: "rostering.person.roles.view",

  //
  ROSTERING_PERSON_ROSTER_BROWSER: "rostering.person.roster.browser",
  // View,
  // View/Sort Browser,
  // Bulk Change Person Status,
  ROSTERING_PERSON_ROSTER_BROWSER_STATUS: "rostering.person.roster.browser.status",
  // Request Transaction,
  ROSTERING_PERSON_TX: "rostering.person.tx",
  // View provider address,
  ROSTERING_PROVIDER_ADDRESS: "rostering.provider.address",
  // View provider credential,
  ROSTERING_PROVIDER_CREDENTIAL: "rostering.provider.credential",
  // Delete Record,
  ROSTERING_PROVIDER_DELETE: "rostering.provider.delete",
  // Edit provider credential,
  ROSTERING_PROVIDER_EDIT: "rostering.provider.edit",
  // View associations,
  ROSTERING_PROVIDER_VIEW: "rostering.provider.view",
  ROSTERING_SITERESTRICTION_EDIT: "rostering.siterestriction.edit",
  ROSTERING_SITERESTRICTION_VIEW: "rostering.siterestriction.view",
  // Edit,
  ROSTERING_WELCOME_GROUP_EDIT: "rostering.welcome.group.edit",
  // View,
  // Change Group,
  // View Menus,
  ROSTERING_WELCOME_MENUS_VIEW: "rostering.welcome.menus.view",
  // View My Roster Tasks,
  ROSTERING_WELCOME_TASKS_VIEW: "rostering.welcome.tasks.view",
  // View welcome page
  ROSTERING_WELCOME_VIEW: "rostering.welcome.view",
  PORTAL_CTEP_ACCOUNT_NAME_VIEW: "portal.personfinder.ctepaccountname",

  // Admin screen

  ROSTERING_ROLES_SETUP_EDIT: "rostering.roles.setup.edit",
  ROSTERING_ROLES_SETUP_VIEW: "rostering.roles.setup.view",
  ROSTERING_RUMS_EDIT: "rostering.rums.edit",
  ROSTERING_RUMS_VIEW: "rostering.rums.view",
  ROSTERING_APPROVAL_EDIT: "rostering.approval.edit",
  ROSTERING_APPROVAL_VIEW: "rostering.approval.view",
  ROSTERING_ATTRIBUTE_SETUP_EDIT: "rostering.attribute.setup.edit",
  ROSTERING_ATTRIBUTE_SETUP_VIEW: "rostering.attribute.setup.view",
  ROSTERING_COMMITTEES_SETUP_EDIT: "rostering.committees.setup.edit",
  ROSTERING_COMMITTEES_SETUP_VIEW: "rostering.committees.setup.view",
  ROSTERING_LAPS_GRANTS_ADMIN_VIEW: "rostering.lapsgrantadmin.view",
  ROSTERING_LAPS_GRANTS_ADMIN_EDIT: "rostering.lapsgrantadmin.edit",
  ROSTERING_UNREGISTERED_SITES_EDIT: "rostering.unregsites.edit",
  ROSTERING_UNREGISTERED_SITES_VIEW: "rostering.unregsites.view",
  ROSTERING_FWA_MAINTENANCE_EDIT: "rostering.fwamaintenance.edit",
  ROSTERING_FWA_MAINTENANCE_VIEW: "rostering.fwamaintenance.view"
};
export default csmKeys;
